// extracted by mini-css-extract-plugin
module.exports = {"button":"confirmDelete_button__jcXuK","warningTxt":"confirmDelete_warningTxt__3fMXN"};